/* Parts finder steps (snippets/parts-steps.liquid). Points steps 2 and 3 at one sprayer once the painter has picked it:
   step 2 to that sprayer's parts diagram (product page #parts), step 3 to the spare parts that fit it (?model=).
   On the homepage the sprayer comes from the band's own select. On the spare parts collection it comes from the fit
   filter's "Your sprayer" (?model= in the URL, which fit-filter.js keeps current), and step 1 focuses that select.
   Product title to model name: the same rules as RULES in assets/fit-filter.js (and MODEL_RULES in
   ops/lib/fit_models.mjs), so the slug is the fit filter's ?model= value. Keep the three in step. */
(() => {
  const RULES = [[/Ultra QuickShot II/, 'Ultra QuickShot II'], [/Ultra QuickShot/, 'Ultra QuickShot'], [/Ultra Corded Handheld/, 'Ultra Corded Handheld'],
    [/Ultra Max Cordless Handheld/, 'Ultra Max Cordless Handheld'], [/Ultra Cordless Handheld/, 'Ultra Cordless Handheld'],
    [/390 PC Cordless/, '390 PC Cordless'], [/FinishPro GX 19 Cordless/, 'FinishPro GX 19 Cordless'], [/FinishPro GX 19\b/, 'FinishPro GX 19'], [/\bGX 19\b/, 'GX 19'],
    [/Mark V XT HD/, 'Mark V XT HD'], [/GMAX II 3900/, 'GMAX II 3900'], [/GMAX II 5900/, 'GMAX II 5900'],
    [/Ultra (\d{3,4}) XT/, (m) => `Ultra ${m[1]} XT`], [/Ultra (\d{3})\b/, (m) => `Ultra ${m[1]}`]];
  const modelOf = (t) => {
    for (const [re, out] of RULES) { const m = String(t).match(re); if (m) return typeof out === 'function' ? out(m) : out; }
    return null;
  };
  const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  document.querySelectorAll('[data-psteps]').forEach((root) => {
    if (root.dataset.pstepsReady) return;
    root.dataset.pstepsReady = '1';

    /* The moving tiles (parts-steps-media.liquid): arm the timeline, then run it only while the steps are on screen, so
       it starts when the band scrolls into view and rests offscreen. A closed fold on the spare parts strip renders
       nothing, so it never reports as visible and nothing plays until it is opened. Reduced motion, or no
       IntersectionObserver, leaves the finished frame. */
    const steps = root.querySelector('.psteps__list');
    const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (steps && root.querySelector('.psm') && !still && 'IntersectionObserver' in window) {
      root.dataset.motion = 'on';
      new IntersectionObserver((entries) => {
        entries.forEach((e) => root.classList.toggle('is-live', e.isIntersecting));
      }, { rootMargin: '0px 0px -15% 0px' }).observe(steps);
    }

    let list = [];
    try { list = JSON.parse(root.querySelector('[data-psteps-machines]').textContent) || []; } catch (e) { list = []; }
    /* One entry per model, the first sprayer in collection order with drawings (the parts finder page's order) */
    const models = [];
    const bySlug = {};
    list.forEach((m) => {
      const name = modelOf(m.t);
      if (!name) return;
      const s = slug(name);
      if (bySlug[s]) return;
      bySlug[s] = { name, url: m.u };
      models.push(s);
    });
    const partsUrl = root.dataset.partsUrl;
    const finderUrl = root.dataset.finderUrl;
    const diagram = root.querySelector('[data-psteps-diagram]');
    const listLink = root.querySelector('[data-psteps-list]');

    const point = (s) => {
      const m = s && bySlug[s];
      if (m) {
        diagram.href = `${m.url}#parts`;
        diagram.textContent = `Open the ${m.name} diagram`;
        if (listLink) { listLink.href = `${partsUrl}?model=${encodeURIComponent(s)}`; listLink.textContent = `See every part for the ${m.name}`; }
      } else {
        diagram.href = finderUrl;
        diagram.textContent = 'Open the parts diagrams';
        if (listLink) { listLink.href = partsUrl; listLink.textContent = 'See every spare part'; }
      }
    };

    if (root.dataset.pstepsLayout === 'band') {
      /* Homepage: the band's own picker, one option per model that has drawings */
      const pick = root.querySelector('[data-psteps-pick]');
      const sel = root.querySelector('[data-psteps-select]');
      const pickLink = root.querySelector('[data-psteps-pick-link]');
      if (!sel || !models.length) return;
      models.forEach((s) => { const o = document.createElement('option'); o.value = s; o.textContent = bySlug[s].name; sel.appendChild(o); });
      pick.hidden = false;
      if (pickLink) pickLink.hidden = true;
      sel.addEventListener('change', () => point(sel.value));
      point(sel.value);
      return;
    }

    /* Spare parts collection: follow the fit filter. One sprayer picked points the steps at it; none or several, the general links */
    const current = () => {
      const v = new URLSearchParams(window.location.search).get('model') || '';
      const picked = v.split(',').map((x) => x.trim()).filter(Boolean);
      return picked.length === 1 ? picked[0] : '';
    };
    let last = null;
    const sync = () => { const s = current(); if (s !== last) { last = s; point(s); } };
    const later = () => setTimeout(sync, 60);
    sync();
    /* fit-filter.js writes ?model= with history.replaceState, sometimes after it has fetched the rest of the collection,
       so follow the URL itself rather than guessing a delay after the click */
    ['replaceState', 'pushState'].forEach((k) => {
      const orig = history[k];
      history[k] = function (...a) { const out = orig.apply(this, a); later(); return out; };
    });
    document.addEventListener('change', later);
    document.addEventListener('click', later);
    document.addEventListener('ase:plp-updated', later);
    window.addEventListener('popstate', later);
    window.addEventListener('pageshow', later);

    const focusLink = root.querySelector('[data-psteps-focus]');
    if (focusLink) focusLink.addEventListener('click', (e) => {
      const sel = document.querySelector('[data-ff-select]');
      if (!sel || sel.closest('[hidden]')) return; /* no picker on this page: the link goes to the collection */
      e.preventDefault();
      sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sel.focus({ preventScroll: true });
    });
  });
})();
